import { useState } from "react";
import { useSceneStore } from "../store/sceneStore";
import { createShare } from "../lib/share";

export function ShareBox() {
  const objects = useSceneStore((s) => s.objects);
  const settings = useSceneStore((s) => s.settings);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCreate = async () => {
    setLoading(true);
    setError("");
    try {
      const link = await createShare(objects, settings);
      setUrl(link);
    } catch {
      setError("Teilen fehlgeschlagen (nur auf der deployten Seite verfügbar)");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button disabled={objects.length === 0 || loading} onClick={handleCreate}>
        {loading ? "Erzeuge Link…" : "Link erzeugen"}
      </button>
      {url && (
        <div className="share-box" style={{ marginTop: 6 }}>
          <input type="text" readOnly value={url} onFocus={(e) => e.target.select()} />
          <button onClick={() => navigator.clipboard.writeText(url)}>Kopieren</button>
        </div>
      )}
      {error && <p style={{ color: "var(--danger)", fontSize: 12 }}>{error}</p>}
    </div>
  );
}
